import { Tooltip } from "components/Tooltip/Tooltip"

/**
 * Tooltip of a `Button`-like control, rendered as a sibling of the control: a
 * tooltip element inside a button is invalid markup. Only mount it when there is
 * tooltip text: every react-tooltip instance attaches a document-wide
 * MutationObserver, which is wasteful for the many buttons without a tooltip
 * (e.g. table cells).
 */
export const ButtonTooltip = ({ id }: { id: string }) => (
  <Tooltip id={id} className="!z-50 !rounded-md !bg-gray-900 !px-3 !py-2 !text-body3/regular !text-white" />
)
